<script setup lang="ts">
import type { SiteSectionsTreeSectionCategoryFilterOption } from "@/app/tools/new-section-management/site-sections-tree/filters/section-category-filter/site-sections-tree-section-category-filter.types";

import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";

const props = defineProps<{
  option: SiteSectionsTreeSectionCategoryFilterOption;
}>();
</script>

<template>
  <span
    class="min-w-0 flex-1 truncate text-sm font-semibold text-text-secondary"
    :data-test-id="DATA_TEST_IDS.components.siteSectionsTreeSectionCategoryFilter.option(props.option.id)"
  >
    {{ props.option.label }}
  </span>
</template>
